import type {App} from 'vue';
import {
  Card,
  ResponsivePage,
  Spinner,
  AnimatedDecimalNumber,
  AnimatedBar,
  DecimalNumber,
  ProgressBar,
  AnimatedNumber,
  BaseInput,
  AmountInput,
} from "./index";


export default {
  install: (app: App) => {
    // @ts-ignore
    app.component('Card', Card);
    app.component('ResponsivePage', ResponsivePage);
    app.component('Spinner', Spinner);
    app.component('AnimatedDecimalNumber', AnimatedDecimalNumber);
    app.component('AnimatedBar', AnimatedBar);
    app.component('DecimalNumber', DecimalNumber);
    app.component('ProgressBar', ProgressBar);
    app.component('AnimatedNumber', AnimatedNumber);
    app.component('BaseInput', BaseInput);
    app.component('AmountInput', AmountInput);
  }
};

export {
  Card,
  ResponsivePage,
  Spinner,
  AnimatedDecimalNumber,
  AnimatedBar,
  DecimalNumber,
  ProgressBar,
  AnimatedNumber,
  BaseInput,
  AmountInput,
}
